import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import styles from './ErrorBlock.sass'
import { extractMessageFromError } from 'utils/error-util'
import { IconButton } from 'components/IconButton'
import Icon from 'components/Icon'

interface ErrorBlockProps {
  error?: unknown
  children?: React.ReactNode
  onCloseClick?: () => unknown
  tackOn?: 'top' | 'bottom'
}

export default observer(function ErrorBlock({
  error,
  children,
  tackOn,
  onCloseClick,
}: ErrorBlockProps) {
  return (
    <div className={cx(styles.root, tackOn ? styles[tackOn] : styles.default)}>
      <div className={styles.icon}>
        <Icon name="info" rotate={180} />
      </div>
      <div className={styles.content}>
        {!!error && extractMessageFromError(error)}
        {children}
      </div>
      {onCloseClick && (
        <div className={styles.actions}>
          <IconButton onClick={() => onCloseClick()}>
            <Icon name="close"></Icon>
          </IconButton>
        </div>
      )}
    </div>
  )
})
